var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", staticClass: "g-core-image-upload-btn" },
    [
      _vm._t("default", function() {
        return [_vm._v(_vm._s(_vm.text))]
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hasImage,
              expression: "!hasImage"
            }
          ],
          staticClass: "g-core-image-upload-form",
          attrs: { method: "post", enctype: "multipart/form-data", action: "" }
        },
        [
          _c("input", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              disabled: _vm.uploading,
              id: "g-core-upload-input-" + _vm.formID,
              name: _vm.name,
              multiple: _vm.multiple,
              type: "file",
              accept: _vm.inputAccept
            },
            on: {
              change: _vm.change,
              dragover: _vm.dragover,
              dragenter: _vm.dragover,
              dragleave: _vm.dragleave,
              dragend: _vm.dragleave,
              drop: _vm.dragleave
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasImage,
              expression: "hasImage"
            }
          ],
          staticClass: "g-core-image-corp-container",
          attrs: { id: "vciu-modal-" + _vm.formID }
        },
        [
          _c("crop", {
            ref: "cropBox",
            attrs: {
              "is-resize": _vm.resize && !_vm.crop,
              ratio: _vm.cropRatio,
              "is-rotate": _vm.rotate
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "info-aside" }, [
            _c(
              "p",
              {
                staticClass: "btn-groups rotate-groups",
                staticStyle: { display: "none" }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-rotate",
                    attrs: { type: "button" },
                    on: { click: _vm.doRotate }
                  },
                  [_vm._v("↺")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-reverserotate",
                    attrs: { type: "button" },
                    on: { click: _vm.doReverseRotate }
                  },
                  [_vm._v("↻")]
                )
              ]
            ),
            _vm._v(" "),
            _vm.crop
              ? _c("p", { staticClass: "btn-groups" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-upload",
                      attrs: { type: "button" },
                      on: { click: _vm.doCrop }
                    },
                    [_vm._v(_vm._s(_vm.cropBtn.ok))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-cancel",
                      attrs: { type: "button" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(_vm._s(_vm.cropBtn.cancel))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.resize && !_vm.crop
              ? _c("p", { staticClass: "btn-groups" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-upload",
                      attrs: { type: "button" },
                      on: { click: _vm.doResize }
                    },
                    [_vm._v(_vm._s(_vm.ResizeBtn.ok))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-cancel",
                      attrs: { type: "button" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(_vm._s(_vm.ResizeBtn.cancel))]
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fdb3c7a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fdb3c7a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-core-image-upload/src/vue-core-image-upload.vue
// module id = 1594
// module chunks = 0